import React from 'react';

import UsersCenter from 'pages/users/containers/usersContainer/usersCenter';

const Users = () => {
  return <UsersCenter />;
};

export default Users;
